<template>
    <v-card class="services elevation-6" shaped>
        <v-card-title>
            <h4 style="word-break: break-word;">
                Out-Patient Care
            </h4>
        </v-card-title>
        <v-divider />
        <v-container>
            <h5 style="word-break: break-word;">
                Receive trustworthy healthcare from HMI-affiliated doctors and medical
                facilities within our quality network.
            </h5>
            <v-btn
                small
                class="teal accent-4 white--text my-4"
                @click="showOutpatient = !showOutpatient"
            >
                Read more
            </v-btn>
        </v-container>

        <!-- DIALOG BOX -->
        <Outpatient
            :show-outpatient="showOutpatient"
            @showDialog="showOutpatientDialog"
        />
    </v-card>
</template>

<script>
import Outpatient from '../DialogBoxes/Outpatient.vue'
export default {
    components: { Outpatient },
    data: () => ({ showOutpatient: false }),
    methods: {
        showOutpatientDialog(showOutpatient) {
            this.showOutpatient = showOutpatient
        }
    }
}
</script>

<style scoped>
.services {
  text-align: justify;
  width: 250px;
}
.services h5 {
  font-weight: normal;
}
@media (max-width: 599px) {
  .services {
    margin-top: 20px;
    width: 95%;
  }
}
@media (min-width: 599px) and (max-width: 1904px) {
  .services {
    margin-top: 15px;
    width: 45%;
  }
}
</style>
